import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.milestonesGrid || initialState;

export const selectMilestonesData = createSelector(
  [selectSlice],
  state => state.data
);

export const selectMilestonesLoading = createSelector(
  [selectSlice],
  state => state.loading
);

export const selectMilestonesInitialLoad = createSelector(
  [selectSlice],
  state => state.initialLoad
);

export const selectMilestonesError = createSelector(
  [selectSlice],
  state => state.error
);

export const selectMilestonesGrid = createSelector(
  [selectSlice],
  state => state
);

export const selectSortSelections = createSelector(
  [selectSlice],
  state => state.sortSelections
);

export const selectIsMetaTableCollapsed = createSelector(
  [selectSlice],
  state => state.isMetaTableCollapsed
);

export const selectColumnConfig = createSelector(
  [selectSlice],
  state => state.columnConfig
);

export const selectColumnConfigLoading = createSelector(
  [selectSlice],
  state => state.columnConfigLoading
);
